var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"overflow-y-auto",attrs:{"height":"300","width":"400px"}},_vm._l((4),function(index){return _c('v-list-item',{key:index},[_c('v-list-item-content',[_c('v-skeleton-loader',{attrs:{"type":"sentences"}})],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }